import { createI18n } from 'vue-i18n'
import pt_BR from './locales/pt_BR.json'

export const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_I18N_LOCALE || 'pt_BR',
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'pt_BR',
  messages: { pt_BR },
  warnHtmlMessage: false,
})
